import { makeFieldValueDbModule } from '../makeFieldValueDbModule';
import { clear as installationBasisServiceClear } from './installationBasisService';
import { makeClearPublisher } from 'serviceWorker/broadcasts/publishers';
import { fieldValueContracts } from 'shared/domain/fieldValue/fieldValueContracts';
import { EditableFieldValuesEntityName } from 'shared/domain/fieldValue/fields';

export const {
  clear,
  quantity,
  get,
  getOne,
  addBatch,
  updateBatch,
  removeBatch,
} = makeFieldValueDbModule({
  tableName: 'installationBasis',
  serviceTableName: 'installationBasisService',
  serviceClearFunction: installationBasisServiceClear,
  broadcastClearFunction: makeClearPublisher(fieldValueContracts[EditableFieldValuesEntityName.installationBasis]),
});
